export function parseWhatsappLink(link) {
  if (!link) return null;

  const isLink =
    /(https?:\/\/)?([\w.-]+)\.([\w.]{2,6})(([\w\-._~:/?#[\]@!$&'()*+,;=]|(%[0-9a-fA-F]{2}))*)\/?$/.test(
      link
    );
  const parsedPhone = link.replace(/\D/g, '');

  return isLink ? link : `https://wa.me/${parsedPhone}`;
}
